(function () {
  'use strict';

  const STORAGE_KEY = 'mm_wishlist_v1';

  function readWishlist() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);

      if (!stored) {
        return [];
      }

      const parsed = JSON.parse(stored);

      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('[MM Wishlist] Could not read wishlist', error);
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(items)
      );
    } catch (error) {
      console.warn('[MM Wishlist] Could not save wishlist', error);
    }
  }

  function notify(action, item) {
    document.dispatchEvent(
      new CustomEvent('mm:wishlist:changed', {
        detail: {
          action: action,
          item: item,
          items: readWishlist()
        }
      })
    );
  }

  function trackAddToWishlist(item) {
    if (!item) return;

    const price = Number(item.price) || 0;
    const quantity = Number(item.quantity) || 1;

    window.dataLayer = window.dataLayer || [];

    // Prevent ecommerce data from a previous event
    // from leaking into this event.
    window.dataLayer.push({
      ecommerce: null
    });

    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: item.currency || 'EUR',
        value: price * quantity,
        items: [
          {
            item_id: String(item.productId || ''),
            item_name: item.title || '',
            item_variant:
              item.selectedSize ||
              item.variantTitle ||
              '',
            variant_id: String(item.variantId || ''),
            price: price,
            quantity: quantity
          }
        ]
      }
    });

    console.log('[MM Wishlist] add_to_wishlist pushed', {
      item_id: item.productId,
      item_name: item.title,
      item_variant:
        item.selectedSize ||
        item.variantTitle ||
        '',
      variant_id: item.variantId,
      price: price,
      quantity: quantity,
      currency: item.currency || 'EUR'
    });
  }

  window.MMWishlist = {
    getAll() {
      return readWishlist();
    },

    has(productId) {
      return readWishlist().some(
        item =>
          String(item.productId) ===
          String(productId)
      );
    },

    add(item) {
      if (!item || !item.productId) {
        return false;
      }

      const items = readWishlist();

      const alreadyExists = items.some(
        existing =>
          String(existing.productId) ===
          String(item.productId)
      );

      if (alreadyExists) {
        return false;
      }

      items.push(item);

      saveWishlist(items);

      notify('add', item);

      // Push ecommerce event to GTM
      trackAddToWishlist(item);

      return true;
    },

    remove(productId) {
      const items = readWishlist();

      const removedItem = items.find(
        item =>
          String(item.productId) ===
          String(productId)
      );

      const newItems = items.filter(
        item =>
          String(item.productId) !==
          String(productId)
      );

      saveWishlist(newItems);

      if (removedItem) {
        notify('remove', removedItem);
      }

      return Boolean(removedItem);
    },

    toggle(item) {
      if (!item || !item.productId) {
        return false;
      }

      if (this.has(item.productId)) {
        this.remove(item.productId);
        return false;
      }

      this.add(item);
      return true;
    },

    clear() {
      localStorage.removeItem(STORAGE_KEY);

      notify('clear', null);
    },

    count() {
      return readWishlist().length;
    }
  };

  console.log(
    '[MM Wishlist] Core loaded',
    window.MMWishlist.getAll()
  );
})();